import { render, staticRenderFns } from "./bookingWorkspace.vue?vue&type=template&id=5992a7f7&scoped=true&"
import script from "./bookingWorkspace.vue?vue&type=script&lang=js&"
export * from "./bookingWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./bookingWorkspace.vue?vue&type=style&index=0&id=5992a7f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5992a7f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5992a7f7')) {
      api.createRecord('5992a7f7', component.options)
    } else {
      api.reload('5992a7f7', component.options)
    }
    module.hot.accept("./bookingWorkspace.vue?vue&type=template&id=5992a7f7&scoped=true&", function () {
      api.rerender('5992a7f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/bookingWorkspace.vue"
export default component.exports